module.exports = __webpack_public_path__ + "img/eematico-toys-jucarii-scientists.67cea6c6.jpg";